import { Outlet } from "react-router-dom";
import { SubNavBar, SubNavBarRow, SubNavLink } from "~/components/build/Show/components/SubNavLink";
import useQueryParams from "~/components/build/Show/lib/useQueryParams";
import { applySearchParams } from "~/components/build/Show/lib/urlForView";

export default function SummaryPage() {
  const params = useQueryParams();

  return (
    <div
      data-testid="summary"
      className="flex min-w-0 flex-auto flex-col rounded-b-md bg-slate-100"
    >
      <SubNavBar>
        <SubNavBarRow>
          <SubNavLink to={applySearchParams(".", params)} end={true}>
            Overview
          </SubNavLink>

          <SubNavLink to={applySearchParams("./step-uploads", params)}>Step uploads</SubNavLink>
        </SubNavBarRow>
      </SubNavBar>

      <div className="relative flex min-w-0 flex-auto flex-col">
        <div className="absolute flex h-full w-full overflow-y-auto">
          <div className="relative flex w-full flex-col gap-2">
            <div className="flex-1 p-3">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
